import React from "react";
import { useHistory } from "react-router-dom";
import { Card, Button, Box } from "@mui/material";
import { ArrowBackIos } from "@mui/icons-material";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";

const TicketHeader = ({ loading, children }) => {
	const history = useHistory();

	const handleBack = () => {
		history.push("/tickets");
	};

	return (
		<>
			{loading ? (
				<TicketHeaderSkeleton />
			) : (
				<Card
					id="TicketHeader"
					square
					elevation={0}
					sx={{
						display: "flex",
						alignItems: "center",
						// borderBottom: 1,
						// borderColor: "divider",
						height: "65px", // Kept specific height for layout stability
						p: 1,
						flexShrink: 0, // Prevent header from shrinking/collapsing
						backgroundColor: 'background.paper', // Uses theme background
					}}
				>
					<Button
						color="primary"
						onClick={handleBack}
						sx={{ minWidth: 'auto', p: 1, mr: 1, display: { md: 'none' } }} // Hide on desktop if side-by-side
					>
						<ArrowBackIos />
					</Button>
					{children}
				</Card>
			)}
		</>
	);
};

export default TicketHeader;
